export default __webpack_public_path__ + "static/media/bg.24c8d33b.png";